<template>
    <div id="openedBy">
        <template v-if="rosterOpenedBys.length > 0">
            <RosterOpenedByPerson
                v-for="rosterOpenedBy in rosterOpenedBys"
                :openedBy="rosterOpenedBy"
                :updateSecondsAgo="updateSecondsAgo"
                :key="rosterOpenedBy.name + '-' + rosterOpenedBy.lastActivitySecondsAgo"
            /><!-- there's no identifiers in there, so what else should I base the :key on? -->
        </template>
    </div>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import RosterOpenedByPerson from '@/components/FilterBar/RosterOpenedByPerson.vue';
    import {ApiClient, RosterOpenedBy as ApiRosterOpenedBy} from '@cquential/api';
    import Dates from '@cquential/date-utils';
    import {RosterViewSettings} from '@/types';
    import GlobalErrorModal from '@/components/modals/GlobalErrorModal.vue';

    @Component({
        components: {
            RosterOpenedByPerson,
        },
    })
    export default class RosterOpenedBy extends Vue {
        @Prop({required: true}) public rosterViewSettings!: RosterViewSettings;

        private static readonly INFO_UPDATE_INTERVAL_TIME: number = 30000;
        private static readonly TIME_INTERVAL_TIME: number = 5000;

        public rosterOpenedBys: ApiRosterOpenedBy[] = []; // no need to set it in the store if we only use it here
        private dataUpdateIntervalId: number | null = null;
        private timerIntervalId: number | null = null;
        private lastUpdate: Date | null = null;
        public updateSecondsAgo: number = 0;

        public mounted(): void {
            this.updateData();
            this.dataUpdateIntervalId = setInterval(this.updateData, RosterOpenedBy.INFO_UPDATE_INTERVAL_TIME);
            this.timerIntervalId = setInterval(this.updateTimer, RosterOpenedBy.TIME_INTERVAL_TIME);
        }

        public beforeUnmount(): void {
            if (this.dataUpdateIntervalId) {
                clearInterval(this.dataUpdateIntervalId);
                this.dataUpdateIntervalId = null;
            }
            if (this.timerIntervalId) {
                clearInterval(this.timerIntervalId);
                this.timerIntervalId = null;
            }
        }

        private updateData(): void {
            // send ping
            ApiClient.instance
                .pingRosterOpen(this.rosterViewSettings.rosterId, this.rosterViewSettings.startDate, Dates.Utils.addDays(this.rosterViewSettings.startDate, this.rosterViewSettings.visibleDays - 1))
                .then((): void => {
                    // once ping succeeded, fetch list
                    ApiClient.instance
                        .fetchRosterOpenedBy(this.rosterViewSettings.rosterId)
                        .then((loadedRosterOpenedBys: ApiRosterOpenedBy[]): void => {
                            this.rosterOpenedBys = loadedRosterOpenedBys;
                            this.lastUpdate = new Date();
                            this.updateSecondsAgo = 0;
                        })
                        /** @see GlobalErrorModal.globalErrorHandler() */
                        // @ts-expect-error TS2339
                        .catch(GlobalErrorModal.__vfdConstructor.globalErrorHandler);
                })
                /** @see GlobalErrorModal.globalErrorHandler() */
                // @ts-expect-error TS2339
                .catch(GlobalErrorModal.__vfdConstructor.globalErrorHandler);
        }

        private updateTimer(): void {
            if (this.lastUpdate) {
                this.updateSecondsAgo = Math.round((Date.now() - this.lastUpdate.valueOf()) / 1000);
            }
        }
    }
</script>

<style lang="scss" scoped>
    #openedBy {
        margin-right: 30px; // keep spacing for collapse button
    }
</style>
